/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GlobalFilterDelete,
    GlobalFilterDeleteFromJSON,
    GlobalFilterDeleteToJSON,
    GlobalFilterListConfiguration,
    GlobalFilterListConfigurationFromJSON,
    GlobalFilterListConfigurationToJSON,
    GlobalFilterListItemPaginationWrapper,
    GlobalFilterListItemPaginationWrapperFromJSON,
    GlobalFilterListItemPaginationWrapperToJSON,
    GlobalFilterQuery,
    GlobalFilterQueryFromJSON,
    GlobalFilterQueryToJSON,
    GlobalFilterRuleListConfiguration,
    GlobalFilterRuleListConfigurationFromJSON,
    GlobalFilterRuleListConfigurationToJSON,
    GlobalFilterRuleListItem,
    GlobalFilterRuleListItemFromJSON,
    GlobalFilterRuleListItemToJSON,
    GlobalFilterRuleListQuery,
    GlobalFilterRuleListQueryFromJSON,
    GlobalFilterRuleListQueryToJSON,
    GlobalFilterState,
    GlobalFilterStateFromJSON,
    GlobalFilterStateToJSON,
    GlobalFilterStateResponse,
    GlobalFilterStateResponseFromJSON,
    GlobalFilterStateResponseToJSON,
} from '../models';

export interface ApiGlobalFiltersGlobalFilterRuleListDataPostRequest {
    globalFilterRuleListQuery?: GlobalFilterRuleListQuery;
}

export interface ApiGlobalFiltersV2GlobalFilterRuleListDeleteGlobalFilterBulkDeleteRequest {
    globalFilterDelete: Array<GlobalFilterDelete>;
}

export interface ApiGlobalFiltersV2GlobalFilterRuleListListPostRequest {
    globalFilterQuery?: GlobalFilterQuery;
}

export interface ApiGlobalFiltersV2GlobalFilterRuleListUpdateStateBulkPostRequest {
    globalFilterState: Array<GlobalFilterState>;
}

/**
 * no description
 */
export class GlobalFilterRuleListApi extends runtime.BaseAPI {

    /**
     */
    async apiGlobalFiltersGlobalFilterRuleListConfigurationGetRaw(): Promise<runtime.ApiResponse<GlobalFilterRuleListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFilters/GlobalFilterRuleList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterRuleListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFiltersGlobalFilterRuleListConfigurationGet(): Promise<GlobalFilterRuleListConfiguration> {
        const response = await this.apiGlobalFiltersGlobalFilterRuleListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiGlobalFiltersGlobalFilterRuleListDataPostRaw(requestParameters: ApiGlobalFiltersGlobalFilterRuleListDataPostRequest): Promise<runtime.ApiResponse<Array<GlobalFilterRuleListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFilters/GlobalFilterRuleList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalFilterRuleListQueryToJSON(requestParameters.globalFilterRuleListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GlobalFilterRuleListItemFromJSON));
    }

    /**
     */
    async apiGlobalFiltersGlobalFilterRuleListDataPost(requestParameters: ApiGlobalFiltersGlobalFilterRuleListDataPostRequest): Promise<Array<GlobalFilterRuleListItem>> {
        const response = await this.apiGlobalFiltersGlobalFilterRuleListDataPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleListDeleteGlobalFilterBulkDeleteRaw(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleListDeleteGlobalFilterBulkDeleteRequest): Promise<runtime.ApiResponse<Array<GlobalFilterStateResponse>>> {
        if (requestParameters.globalFilterDelete === null || requestParameters.globalFilterDelete === undefined) {
            throw new runtime.RequiredError('globalFilterDelete','Required parameter requestParameters.globalFilterDelete was null or undefined when calling apiGlobalFiltersV2GlobalFilterRuleListDeleteGlobalFilterBulkDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleList/DeleteGlobalFilterBulk`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.globalFilterDelete.map(GlobalFilterDeleteToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GlobalFilterStateResponseFromJSON));
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleListDeleteGlobalFilterBulkDelete(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleListDeleteGlobalFilterBulkDeleteRequest): Promise<Array<GlobalFilterStateResponse>> {
        const response = await this.apiGlobalFiltersV2GlobalFilterRuleListDeleteGlobalFilterBulkDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleListGetListConfigurationGetRaw(): Promise<runtime.ApiResponse<GlobalFilterListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleList/GetListConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleListGetListConfigurationGet(): Promise<GlobalFilterListConfiguration> {
        const response = await this.apiGlobalFiltersV2GlobalFilterRuleListGetListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleListListPostRaw(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleListListPostRequest): Promise<runtime.ApiResponse<GlobalFilterListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleList/List`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalFilterQueryToJSON(requestParameters.globalFilterQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleListListPost(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleListListPostRequest): Promise<GlobalFilterListItemPaginationWrapper> {
        const response = await this.apiGlobalFiltersV2GlobalFilterRuleListListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleListUpdateStateBulkPostRaw(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<GlobalFilterStateResponse>>> {
        if (requestParameters.globalFilterState === null || requestParameters.globalFilterState === undefined) {
            throw new runtime.RequiredError('globalFilterState','Required parameter requestParameters.globalFilterState was null or undefined when calling apiGlobalFiltersV2GlobalFilterRuleListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleList/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.globalFilterState.map(GlobalFilterStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GlobalFilterStateResponseFromJSON));
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleListUpdateStateBulkPost(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleListUpdateStateBulkPostRequest): Promise<Array<GlobalFilterStateResponse>> {
        const response = await this.apiGlobalFiltersV2GlobalFilterRuleListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
